import Init from "./init";

class MembershipDB {
  static initPath = (path) => {
    return `/api/membership${path}`;
  };

  static getByPage = async ({ page, pageSize, keyword }) => {
    const data = { page, pageSize, keyword };
    const res = await Init.fnInit("/api/membership/getPaginator", data);

    return res;
  };

  static getByStudent = async ({ studentId }) => {
    const data = { studentId };
    const res = await Init.fnInit("/api/membership/getByStudent", data);

    return res;
  };

  static getOne = async ({ memberId }) => {
    const data = { memberId };
    const res = await Init.fnInit("/api/membership/getOne", data);

    return res;
  };

  static getAll = async () => {
    const res = await Init.fnInit("/api/membership/getAll");

    return res;
  };

  static getByMonth = async ({ date, student_id }) => {
    const data = { date, student_id };
    const res = await Init.fnInit("/api/membership/getByMonth", data);

    return res;
  };

  static add = async ({
    user_id,
    student_id,
    duration,
    expire_at,
    description,
    amount,
    date,
    start_date,
    payment_method,
  }) => {
    const data = {
      user_id,
      student_id,
      duration,
      expire_at,
      description,
      amount,
      date,
      start_date,
      payment_method,
    };
    const res = await Init.fnInit("/api/membership/create", data);

    return res;
  };

  static update = async ({ user_id, student_id, duration, expire_at, description }) => {
    const data = {
      user_id,
      student_id,
      duration,
      expire_at,
      description,
    };
    const res = await Init.fnInit("/api/membership/update", data);

    return res;
  };

  static delete = async ({ id }) => {
    const data = { id };
    const res = await Init.fnInit("/api/membership/delete", data);

    return res;
  };

  static deactivate = async ({ id }) => {
    const data = { id };
    const res = await Init.fnInit("/api/membership/deactivate", data);

    return res;
  };
}

export default MembershipDB;
